import { Tag } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const StateTag = ({
  state,
  className,
  onlineText = '',
  offlineText = '',
}) => {
  const { t } = useTranslation();
  return (
    <Tag
      color={state === 1 ? '#0e9347' : '#4f4d4d'}
      style={{ height: 'fit-content' }}
      className={className}
    >
      {state === 1 ? onlineText || t('Online') : offlineText || t('Offline')}
    </Tag>
  );
};
